export default {
      id: "dazzle-sandtimer-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.68fd9e19.svg#dazzle-sandtimer",
      toString: function () {
        return this.url;
      }
    }